import { FC } from 'react'
import BaseError from './BaseError'

const ServerError: FC<{ onClose: () => void }> = ({ onClose }) => {
  return (
    <BaseError
      onClose={onClose}
      header="Our Service is Temporarily Unavailable"
      message={
        <>
          Please try again in a few minutes. If the problem persists, contact
          Customer Support at <strong>(844) 552-7444</strong> or{' '}
          <strong>support@brightmls.com</strong> for assistance.
        </>
      }
    />
  )
}

export default ServerError
